import { NodeWithSize } from '../types';

export const isNodeWithSize = (node: BaseNode): node is NodeWithSize => {
  return !!(node as NodeWithSize).width && !!(node as NodeWithSize).height;
};
